export default class AccessibilityLink {
  accessibilityLinkHref = '#accessibility';

  initialize = () => {
    const linkElement = document.querySelector(`a[href="${this.accessibilityLinkHref}"`);

    if (linkElement) {
      linkElement.dataset.acsbCustomTrigger = true;
    }
  };
}
